module.exports = __webpack_public_path__ + "0812f4a1eb35acafd4afdb5ed563cd72.svg";